import { motion } from "framer-motion"

const slideConf = {
  enter: {
    opacity: 1,
    position: "relative",
    // x: 0,
    transition: { duration: 0.15 },
  },
  exit: {
    opacity: 0,
    position: "absolute",
    // x: "50%",
    transition: { duration: 0.15 },
    transtitionEnd: {
      position: "relative",
    },
  },
}

export const MainContainer = (props) => (
  <motion.div
    className="bg-white"
    initial="hidden"
    transition={{ type: "linear" }}
    variants={{
      hidden: {
        opacity: 0,
        position: "absolute",
        transition: { duration: 0.3 },
        transitionEnd: { position: "absolute" },
      },
      show: {
        opacity: 1,
        position: "relative",
        transition: { duration: 0.3 },
        transitionEnd: { position: "relative" },
      },
    }}
    {...props}
  />
)

export const SlideContainer = (props) => (
  <motion.div
    animate="enter"
    className="h-full bg-white"
    exit="exit"
    initial="exit"
    transition={{ type: "linear" }}
    variants={slideConf}
    {...props}
  />
)
